export function formatDate(date) {
	try {
		const options = {
			weekday: 'short',
			month: 'short',
			day: '2-digit',
			year: 'numeric',
			hour: '2-digit',
			minute: '2-digit',
			// second: '2-digit',
			hour12: true,
		};

		let formattedDate = new Intl.DateTimeFormat('en-US', options).format(new Date(date));

		// Custom formatting to match "Mon, Dec 23/2024 5:25:00 AM"
		formattedDate = formattedDate
			.replace(',', '')
			.replace(' ', ', ')
			.replace(/(\d{2}) (\d{4})/, '$1/$2');

		return formattedDate;
	} catch (e) {
		// console.error('e: ', e);
		return '';
	}
}

export const GameDiv = (props) => {
	const { dataRow, selected } = props;

	return (
		<div style={{ backgroundColor: selected ? '#363844' : '' }}>
			<div style={{ backgroundColor: selected ? '#363844' : '' }} className="text-xs">
				{formatDate(dataRow.game?.start_date)}
			</div>
			{dataRow.game?.away_team_display} @ {dataRow.game?.home_team_display}
		</div>
	);
};
